import * as constants from "./constants";

const initialState = {
  allLocations: [],
  currentLocationObj: {},
  utilsData: {},
  updateNotLoading: false,
  createLocationLoading: false,
  locationDetailsIsEdit: false,
  fetchLocationsLoading: false,
  deleteLocationLoading: false,
  fetchLocationDetailLoading: false,
  totalRecords: 0,
  deleteAttachLoading: false,
  locationNotificationIsEdit: false,
};

const locationManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    // Removed reference to missing constant
    // We'll handle utils data through other actions
    case constants.LOCATION_DETAILS_IS_EDIT:
      return {
        ...state,
        locationDetailsIsEdit: action.data,
      };

    case constants.CREATE_LOCATION:
      return {
        ...state,
        createLocationLoading: true,
      };
    case constants.CREATE_LOCATION_SUCCESS:
      return {
        ...state,
        createLocationLoading: false,
        currentLocationObj: action.data,
        locationDetailsIsEdit: false,
      };
    case constants.CREATE_LOCATION_ERROR:
      return {
        ...state,
        createLocationLoading: false,
      };
    case constants.UPDATE_LOCATION:
      return {
        ...state,
        createLocationLoading: true,
      };
    case constants.UPDATE_LOCATION_SUCCESS:
      return {
        ...state,
        createLocationLoading: false,
        currentLocationObj: action.data,
        locationDetailsIsEdit: false,
      };
    case constants.UPDATE_LOCATION_ERROR:
      return {
        ...state,
        createLocationLoading: false,
      };

    case constants.UPDATE_LOCATION_NOTIFICATION:
      return {
        ...state,
        updateNotLoading: true,
      };
    case constants.UPDATE_LOCATION_NOTIFICATION_SUCCESS:
      return {
        ...state,
        updateNotLoading: false,
        locationNotificationIsEdit: false,
      };
    case constants.UPDATE_LOCATION_NOTIFICATION_ERROR:
      return {
        ...state,
        updateNotLoading: false,
      };

    case constants.FETCH_ALL_LOCATIONS:
      return {
        ...state,
        fetchLocationsLoading: true,
      };
    case constants.FETCH_ALL_LOCATIONS_SUCCESS:
      const locationsList = action.data?.data || [];
      const totalCount = action.data?.total || locationsList.length;
      const processedLocations = locationsList.map(location => ({
        ...location,
        key: location.id
      }));
      return {
        ...state,
        allLocations: processedLocations,
        fetchLocationsLoading: false,
        totalRecords: totalCount,
      };
    case constants.FETCH_ALL_LOCATIONS_ERROR:
      return {
        ...state,
        fetchLocationsLoading: false,
        // Ensure we have an empty array if there's an error
        allLocations: [],
      };
    case constants.DELETE_LOCATION:
      return {
        ...state,
        deleteLocationLoading: true,
      };
    case constants.DELETE_LOCATION_SUCCESS:
      let updatedLocations = state.allLocations.filter(
        (el) => el.id !== action.data.id
      );
      let totalRecords = state.totalRecords - 1;
      let lselectedLocations = JSON.parse(
        localStorage.getItem("lsselectedLocations")
      );

      if (lselectedLocations?.length > 0) {
        let lisCheck = JSON.parse(localStorage.getItem("lsisCheck"));
        let llist = JSON.parse(localStorage.getItem("lslist"));
        let lfilteredLocations = JSON.parse(
          localStorage.getItem("lsfilteredLocations")
        );
        let updatedlsselectedLocations = lselectedLocations.filter(
          (project) => project.id !== action.data.id
        );

        if (updatedlsselectedLocations.length > 0) {
          localStorage.setItem(
            "lsselectedLocations",
            JSON.stringify(updatedlsselectedLocations)
          );

          if (lselectedLocations !== null) {
            let userLocationsIds = updatedLocations.map((el) => el.id);

            let updatedLsfilteredLocations = lfilteredLocations.filter((el) =>
              userLocationsIds.includes(el.id)
            );

            let updatedlsisCheck = lisCheck.filter((id) =>
              userLocationsIds.includes(id)
            );
            let updatedlslist = llist.filter((el) =>
              userLocationsIds.includes(el.id)
            );

            localStorage.setItem(
              "lsselectedLocations",
              JSON.stringify(updatedlsselectedLocations)
            );
            localStorage.setItem(
              "lsfilteredLocations",
              JSON.stringify(updatedLsfilteredLocations)
            );

            localStorage.setItem("lsisCheck", JSON.stringify(updatedlsisCheck));
            localStorage.setItem("lslist", JSON.stringify(updatedlslist));
          }
        } else {
          localStorage.removeItem("lsselectedLocations");
          localStorage.removeItem("lsfilteredLocations");
          localStorage.removeItem("lsisCheck");
          localStorage.removeItem("lslist");
        }
      }

      return {
        ...state,
        totalRecords: totalRecords,
        deleteLocationLoading: false,
        allLocations: updatedLocations,
      };
    case constants.DELETE_LOCATION_ERROR:
      return {
        ...state,
        deleteLocationLoading: false,
      };

    case constants.DELETE_LOCATION_ATTACH:
      return {
        ...state,
        deleteAttachLoading: true,
      };
    case constants.DELETE_LOCATION_ATTACH_SUCCESS:
      const { id } = action.data;

      let updatedDocs = state.currentLocationObj.document_urls.filter(
        (el) => el.id != id
      );

      return {
        ...state,
        deleteAttachLoading: false,
        currentLocationObj: {
          ...state.currentLocationObj,
          document_urls: updatedDocs,
        },
      };
    case constants.DELETE_LOCATION_ATTACH_ERROR:
      return {
        ...state,
        deleteAttachLoading: false,
      };

    case constants.FETCH_LOCATION:
      return {
        ...state,
        // departmentLoading: true,
        fetchLocationDetailLoading: true,
      };
    case constants.FETCH_LOCATION_SUCCESS:
      return {
        ...state,
        currentLocationObj: action.data,
        fetchLocationDetailLoading: false,
      };
    case constants.FETCH_LOCATION_ERROR:
      return {
        ...state,
        fetchLocationDetailLoading: false,
      };

    case constants.LOCATION_NOTIF_IS_EDIT:
      return {
        ...state,
        locationNotificationIsEdit: action.data,
      };

    case constants.LOCATION_DETAIL_CLEANUP_FUNC:
      return {
        ...state,
        allLocations: [],
        createLocationLoading: false,
        currentLocationObj: {},
        locationDetailsIsEdit: false,
        fetchLocationsLoading: false,
        deleteLocationLoading: false,
        locationNotificationIsEdit: false,
      };
    default:
      return state;
  }
};

export default locationManagerReducer;
